import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = 'https://api.gamedatarun.com/';
Vue.use(BlackDashboard);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
export const store = new Vuex.Store();

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
